// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const BellIcon = /* @__PURE__ */ createIcon(
  'bell',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M13.983 20.25a1 1 0 0 1 1.325 1.5A5 5 0 0 1 12 23a5 5 0 0 1-3.308-1.25 1 1 0 0 1 1.324-1.5c.53.467 1.223.75 1.984.75s1.454-.283 1.983-.75M17 8A5 5 0 0 0 7 8c0 3.268-.828 5.568-1.802 7.134q-.317.51-.534.864l.725.002H18.61q.416 0 .724-.002-.217-.354-.534-.864C17.827 13.568 17 11.268 17 8m2 0c0 2.913.732 4.844 1.499 6.077.363.583.65 1.044.842 1.378.095.166.182.325.247.467.032.07.068.157.096.25.023.08.068.247.051.45-.01.137-.04.37-.174.612a1.5 1.5 0 0 1-.427.471c-.254.188-.546.229-.638.242a5 5 0 0 1-.483.04c-.34.014-.813.013-1.402.013H5.39c-.589 0-1.062 0-1.402-.013a5 5 0 0 1-.483-.04c-.091-.013-.384-.054-.638-.242a1.5 1.5 0 0 1-.429-.47 1.5 1.5 0 0 1-.172-.613 1.2 1.2 0 0 1 .05-.45c.028-.093.065-.18.097-.25.064-.142.15-.302.246-.467.193-.334.48-.795.842-1.378C4.267 12.844 5 10.913 5 8a7 7 0 1 1 14 0',
      },
    ],
  ]
);
